<template>
  <section>
    <div class="container">
      <b-card class="shadow p-3 mb-5 bg-white rounded m-4">
        <b-row>
          <b-col cols="4">
            <b-link class="text-left h4" to="/dashboard"><b-icon icon="arrow-left-circle"></b-icon> Kembali</b-link>
          </b-col>
          <b-col cols="4">
            <b-card-title class="text-center h3">{{ updateSubmit ? 'Edit' : 'Tambah' }} Pembiayaan Motor Baru</b-card-title>
          </b-col>
        </b-row>
        <b-card-body>
          <div v-if="isLoading" class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
            <p class="mt-3">Memuat data...</p>
          </div>
          <div v-else>
            <b-alert v-if="!showForm" show variant="danger">
              Form tidak dapat ditampilkan karena masalah dengan data produk. Silakan cek ulang atau hubungi administrator.
            </b-alert>
            <b-alert v-if="nisbahError" show variant="danger" dismissible @dismissed="nisbahError = ''">
              {{ nisbahError }}
            </b-alert>
            <b-alert v-if="equalRateError" show variant="danger" dismissible @dismissed="equalRateError = ''">
              {{ equalRateError }}
            </b-alert>
            <ValidationObserver v-if="showForm" v-slot="{ handleSubmit }">
              <b-form @submit.prevent="handleSubmit(addProduct)">
                <b-form-group>
                  <label>Nama Produk<span class="text-danger"> *</span></label>
                  <ValidationProvider name="nama produk" rules="required" v-slot="{ errors }">
                    <b-form-input type="text" v-model="form.product_name" required
                      placeholder="Masukan nama produk"></b-form-input>
                    <span class="text-danger">{{ errors[ 0 ] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group>
                  <label>Kategori Produk<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.category_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option
                      v-for="option in options.category"
                      :key="option.value"
                      :value="option.value"
                      :disabled="option.text.toLowerCase().trim() !== 'pembiayaan'"
                    >
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group>
                  <label>Sub Kategori Produk<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.sub_category_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in filteredSubCategories" :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <label>Merk <span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.brand_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in filteredBrandOprions" :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <label>Sub Merk <span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.sub_brand_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option v-for="option in filteredsubBrandOprions" :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <div v-if="selectedVariantImages.length > 0" class="mt-3 mb-3">
                  <label class="d-block mb-2">Varian</label>
                  <div class="d-flex flex-wrap gap-3">
                    <div
                      v-for="(img, index) in selectedVariantImages"
                      :key="index"
                      class="text-center border rounded p-2 mr-3"
                      style="width: 120px; height: 150px; display: flex; flex-direction: column; align-items: center; justify-content: center;"
                    >
                      <div
                        style="width: 100px; height: 100px; overflow: hidden; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 4px;"
                      >
                      <img
                        :src="img.fullImageUrl"
                        alt="Variant Image"
                        style="max-width: 100%; max-height: 100%; object-fit: contain; cursor: pointer;"
                        @click="openZoomModal(img.fullImageUrl, img.variant)"
                      />
                      </div>
                      <div class="mt-2 text-truncate" style="max-width: 100px;">{{ img.variant }}</div>
                    </div>
                  </div>
                </div>
                <b-modal
                  v-model="showZoomModal"
                  size="lg"
                  centered
                  hide-footer
                  hide-header
                >
                  <div class="text-center">
                    <div class="mb-3 font-weight-bold h5">{{ zoomVariant }}</div>
                    <img :src="zoomImage" alt="Zoomed Variant" style="max-width: 100%; max-height: 80vh;" />
                  </div>
                </b-modal>
                <b-form-group>
                  <label>Jenis Akad<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.akad_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option
                      v-for="option in filteredAkadOptions"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <label>Harga<span class="text-danger"> *</span></label>
                  <b-form-input
                    id="input-setoran-awal-minimum"
                    v-model="formattedHarga"
                    @input="handleHargaInput"
                    @keypress="onlyNumberKey"
                    type="text"
                    inputmode="numeric"
                    placeholder="Masukkan Harga"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group>
                  <label>Tipe Margin<span class="text-danger"> *</span></label>
                  <b-form-select v-model="form.margin_type_id" required>
                    <b-form-select-option disabled value="">Silahkan Pilih ....</b-form-select-option>
                    <b-form-select-option
                      v-for="option in options.margin_type"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ capitalizeWords(option.text) }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <div class="row">
                    <div class="col-md-6">
                      <label for="down_payment" class="block text-sm font-medium text-gray-700">Minimum Down Payment (DP) / Uang Muka <span class="text-danger"> *</span></label>
                      <input
                        type="text"
                        v-model="formattedSetoranAwalMinimum"
                        class="form-control"
                        @input="handleDPInput"
                        placeholder="Masukkan DP / Uang Muka"
                      />
                      <div class="flex items-center mt-1 space-x-2 text-xs">
                        <span class="text-gray-600 whitespace-nowrap">Rekomendasi : </span>
                        <b-button
                          type="button"
                          @click="setDP(20)"
                          :class="getDPButtonClass(20)"
                        >20%</b-button>
                        <b-button
                          type="button"
                          @click="setDP(30)"
                          :class="getDPButtonClass(30)"
                        >30%</b-button>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label>Margin ( p.a. )<span class="text-danger"> *</span></label>
                      <ValidationProvider name="equal rate" :rules="nisbahRules" v-slot="{ errors }">
                        <div class="input-group">
                          <b-form-input type="number" :disabled="disabled === 0" step=".01" v-model="form.margin_amount"
                            placeholder="Masukkan Margin"></b-form-input>
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <i class="fa fa-percent" aria-hidden="true"></i>
                              &nbsp;&nbsp;p.a.
                            </span>
                          </div>
                        </div>
                        <small class="text-danger">{{ errors[ 0 ] }}</small>
                      </ValidationProvider>
                    </div>
                  </div>
                </b-form-group>
                <b-form-group>
                  <label>Jangka Waktu (bulan)<span class="text-danger"> *</span></label><br>
                  <b-form-select v-model="selectedJangkaWaktu" @change="tambahJangkaWaktu">
                    <b-form-select-option disabled value="">
                      Silahkan Pilih ....
                    </b-form-select-option>
                    <b-form-select-option v-for="option in options.tenure_period" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                  <small class="text-muted d-block mt-1">Bisa lebih dari satu</small>
                  <div class="mt-2 d-flex flex-wrap">
                    <div
                      v-for="(item, index) in form.tenure_period"
                      :key="index"
                      class="preview-badge border border-primary rounded px-2 py-1 d-inline-block mr-2 mb-2"
                      style="background-color: #fff;"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <strong>{{ item[0] }} Bulan</strong>
                        <b-button
                          size="sm"
                          variant="link"
                          class="p-0 ml-2 text-danger"
                          style="font-size: 1rem; background-color: transparent;"
                          @click="hapusJangkaWaktu(index)"
                        >
                          &times;
                        </b-button>
                      </div>

                      <small class="text-muted d-block">Premi Asuransi</small>

                      <div class="d-flex align-items-center mt-1">
                        <b-form-input
                          v-model.number="form.tenure_period[index][1]"
                          type="number"
                          step="0.1"
                          min="0"
                          max="100"
                          placeholder="0.0"
                          style="width: 70px; font-size: 0.8rem;"
                          class="py-0 mr-1"
                          @keydown="preventMinus"
                        />
                        <span style="font-size: 0.85rem;">%</span>
                      </div>
                    </div>
                  </div>
                </b-form-group>
                <b-form-group>
                  <label>Cakupan Wilayah<span class="text-danger"> *</span></label>
                  <b-form-select v-model="selectedCity" @change="tambahKota">
                    <b-form-select-option disabled value="">
                      Silahkan Pilih ....
                    </b-form-select-option>
                    <b-form-select-option
                      v-for="option in options.city_arround"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.text }}
                    </b-form-select-option>
                  </b-form-select>
                  <small class="text-muted d-block mt-1">Bisa lebih dari satu</small>
                  <div class="mt-2 d-flex flex-wrap">
                    <div
                      v-for="(kota, index) in form.city_coverage"
                      :key="index"
                      class="preview-badge d-flex align-items-center mr-2 mb-2"
                    >
                      {{ getCityText(kota) }}
                      <b-button
                        variant="link"
                        size="sm"
                        class="close-preview p-0 ml-2 text-danger"
                        @click="hapusKota(index)"
                      >
                        &times;
                      </b-button>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group>
                  <label>Deskripsi<span class="text-danger"> *</span></label>
                  <ValidationProvider name="deskripsi" rules="required" v-slot="{ errors }">
                    <b-form-textarea placeholder="Masukan Deskripsi..." v-model="form.description" rows="3" required
                      max-rows="6"></b-form-textarea>
                    <span class="text-danger">{{ errors[ 0 ] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group label="Biaya administrasi (opsional)">
                  <div class="mb-2">
                    <b-button
                      size="sm"
                      class="btn-switch"
                      :class="{ active: form.is_nominal === true }"
                      @click="setAsNominal"
                    >
                      Nominal
                    </b-button>

                    <b-button
                      size="sm"
                      class="btn-switch"
                      :class="{ active: form.is_nominal === false }"
                      @click="setAsPercentage"
                    >
                      Persentase
                    </b-button>
                  </div>

                  <div v-if="form.is_nominal !== null">
                    <div v-if="form.is_nominal">
                      <b-form-input
                        id="input-biaya-administrasi"
                        v-model="formattedBiayaAdministrasi"
                        type="text"
                        placeholder="Masukan Biaya administrasi"
                      ></b-form-input>
                    </div>

                    <div v-else class="input-group">
                      <b-form-input
                        type="number"
                        step=".01"
                        v-model="form.administration_fee"
                        :state="isValidPercentage"
                        placeholder="Masukkan Persentase Biaya Administrasi"
                        @keydown="preventOverMax"
                        @input="handlePercentageInput"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="fa fa-percent" aria-hidden="true"></i>&nbsp;&nbsp;p.a.
                        </span>
                      </div>
                      <b-form-invalid-feedback v-if="!isValidPercentage">
                        Maksimal 100 persen.
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </b-form-group>

                <b-form-group label="Biaya lain-lain (opsional)">
                  <div class="row">
                    <div class="col">
                      <b-form-input id="input-keterangan" v-model="form.other_fee_description" type="text"
                        placeholder="Masukan Keterangan"></b-form-input>
                    </div>
                    <div class="col">
                      <b-form-input id="input-biaya-lain-lain" v-model="formattedBiayaLainLain"
                        type="text"
                        placeholder="Masukan Nominal Biaya Lain Lain"></b-form-input>
                    </div>
                  </div>
                </b-form-group>
                <b-button 
                  class="mt-4" 
                  block 
                  type="button" 
                  :disabled="isLoadSubmit"
                  @click="validateAndAddProduct" 
                  variant="primary"
                  v-if="!updateSubmit">
                  <b-spinner v-if="isLoadSubmit"></b-spinner>
                  <span v-else>Tambah</span>
                </b-button>

                <b-button 
                  class="mt-4" 
                  block 
                  type="button" 
                  :disabled="isLoadSubmit"
                  @click="updateData" 
                  variant="primary"
                  v-else>
                  <b-spinner v-if="isLoadSubmit"></b-spinner>
                  <span v-else>Simpan</span>
                </b-button>
              </b-form>
            </ValidationObserver>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <b-modal size="sm" v-model="confirmProductModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Apakah anda yakin ingin menambahkan produk ini?</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="confirmAddProduct">Ya</b-button>
        </div>
        <div class="col">
          <b-button class="mt-3" block @click="confirmProductModal = false">Tidak</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
      <div class="d-block text-center">
        <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
        <h3>{{ modalText }}</h3>
      </div>
      <div class="row">
        <div class="col">
          <b-button class="mt-3" block @click="successConfirm">Tutup</b-button>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<style>
  .preview-badge {
    background-color: transparent;
    border: 1px solid #007bff; /* biru Bootstrap */
    color: #007bff;
    border-radius: 20px;
    padding: 0.25rem 0.75rem;
    font-size: 0.875rem;
  }
  .close-preview{
    background-color: transparent;
    border: transparent;
    font-weight: bolder;
  }
</style>
<script>
import AkadSyariah from '../../api/akadsyariah';
import Product from '../../api/produk';
import ProductLending from '../../api/produkLendingV3';
import ProductCategory from '../../api/productcategoryv3';
import SubProductCategory from '../../api/subproductcategoryv3';
import MitraProfile from '../../api/mitraprofile';
import Kota from '../../api/daerahindonesia/kota';
import Brands from '../../api/brandsV3';
import SubBrands from '../../api/subBrandsV3';
import MarginType from '../../api/marginTypes';

export default {
  name: 'PembiayaanForm',
  data() {
    return {
      showForm: true,
      isLoading: false,
      isLoadSubmit: false,
      selectedCity: '',
      selectedJangkaWaktu: '',
      form: {
        id: null,
        mitra_id: null,
        product_name: '',
        description: '',
        category_id: '',
        sub_category_id: '',
        akad_id: '',
        margin_amount: '',
        down_payment: null,
        administration_fee: '',
        is_nominal: null,
        other_fee_description: null,
        other_fee_amount: null,
        tenure_period: [],
        city_coverage: [],
        price: null,
        brand_id: '',
        sub_brand_id: '',
        margin_type_id: ''
      },
      options: {
        akad: [],
        category: [],
        sub_category: [],
        brands: [],
        subBrands: [],
        city_arround: [],
        tenure_period: [
          { text: '12 Bulan', value: 12 },
          { text: '24 Bulan', value: 24 },
          { text: '29 Bulan', value: 29 },
          { text: '35 Bulan', value: 35 },
          { text: '36 Bulan', value: 36 },
        ],
        margin_type: []
      },
      confirmProductModal: false,
      successModal: false,
      updateSubmit: false,
      modalText: '',
      currentUser: '',
      disabled: 1,
      paramsId: null,
      equalRateError: '',
      cityProfile: '',
      pronvisiMitra: '',
      selectedDP: null,
      pembiayaanCategoryUUID: '',
      subBrandImages: [],
      zoomImage: null,
      zoomVariant: '',
      showZoomModal: false,
      lockedPersentase: [],
      nisbahError: '',
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    filteredAkadOptions() {
      if (this.form.category_id === this.pembiayaanCategoryUUID) {
        return this.options.akad.filter(option => option.text.toLowerCase() === 'murabahah');
      } else {
        return this.options.akad;
      }
    },
    nisbahRules() {
      return this.form.akad_id !== 2 ? "required" : "";
    },
    filteredSubCategories() {
      return this.options.sub_category.filter(
        subcategory => subcategory.category_id === this.form.category_id
      );
    },
    filteredBrandOprions() {
      return this.options.brands.filter(
        brand => brand.sub_category_id === this.form.sub_category_id
      );
    },
    filteredsubBrandOprions() {
      return this.options.subBrands.filter(
        subBrand => subBrand.brand_id === this.form.brand_id
      );
    },
    selectedVariantImages() {
      return this.subBrandImages
        .filter(img => img.sub_brand_id === this.form.sub_brand_id)
        .map(img => ({
          ...img,
          fullImageUrl: process.env.API_URL + img.image
        }));
    },
    formattedHarga: {
      get() {
        return this.formatCurrency(this.form.price);
      },
      set(value) {
        this.form.price = this.parseCurrency(value);
      },
    },
    formattedSetoranAwalMinimum: {
      get() {
        return this.formatCurrency(this.form.down_payment);
      },
      set(value) {
        this.form.down_payment = this.parseCurrency(value);
      },
    },
    formattedBiayaAdministrasi: {
      get() {
        return this.formatCurrency(this.form.administration_fee);
      },
      set(value) {
        this.form.administration_fee = this.parseCurrency(value);
      },
    },
    formattedBiayaLainLain: {
      get() {
        return this.formatCurrency(this.form.other_fee_amount);
      },
      set(value) {
        this.form.other_fee_amount = this.parseCurrency(value);
      },
    },
    isValidPercentage() {
      return (
        this.form.is_nominal === false &&
        (this.form.administration_fee === '' || parseFloat(this.form.administration_fee) <= 100)
      );
    }
  },
  watch: {
    'form.category_id'(newVal) {
      if (newVal === this.pembiayaanCategoryUUID) {
        const murabahah = this.options.akad.find(item => item.text.toLowerCase() === 'murabahah');
        this.form.akad_id = murabahah ? murabahah.value : '';
      } else {
        this.form.akad_id = ''; // reset kalau bukan pembiayaan
      }
    },
  },
  mounted() {
    this.loadData();
  },
  created() {
    if (this.$store.state.auth.user) {
      this.currentUser = this.$store.state.auth.user;
    }

    if (this.$route.params.id) {
      this.paramsId = this.$route.params.id;
    }
  },
  methods: {
    handlePercentageInput(e) {
      const value = parseFloat(e.target.value);
      this.form.administration_fee = value > 100 ? 100 : value;
    },

    preventOverMax(e) {
      const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End', '.', ','];
      if (allowedKeys.includes(e.key)) return;

      const newValue = e.target.value + e.key;

      // Cegah jika hasil akhirnya lebih dari 100
      const parsed = parseFloat(newValue.replace(',', '.'));
      if (!isNaN(parsed) && parsed > 100) {
        e.preventDefault();
      }
    },
    setAsNominal() {
      if (this.form.is_nominal !== true) {
        this.form.is_nominal = true;
        this.form.administration_fee = '';
      }
    },
    setAsPercentage() {
      if (this.form.is_nominal !== false) {
        this.form.is_nominal = false;
        this.form.administration_fee = '';
      }
    },
    openZoomModal(imageUrl, variantName) {
      this.zoomImage = imageUrl;
      this.zoomVariant = variantName;
      this.showZoomModal = true;
    },
    setDP(persen) {
      if (!this.form.price) return;
      const price = parseFloat(this.form.price);
      const hasilDP = (price * persen) / 100;
      this.form.down_payment = Math.round(hasilDP);
      this.selectedDP = persen;
    },
    getDPButtonClass(persen) {
      return [
        'px-2 py-1 rounded text-xs font-medium border transition duration-150 ease-in-out',
        this.selectedDP === persen
          ? 'bg-blue-500 text-white border-blue-500'
          : 'border-blue-500 text-blue-500 hover:bg-blue-50'
      ];
    },
    handleHargaInput(e) {
      const onlyNumbers = e.target.value.replace(/\D/g, '');
      this.form.price = onlyNumbers;
    },

    handleDPInput(e) {
      const onlyNumbers = e.target.value.replace(/\D/g, '');
      this.form.down_payment = onlyNumbers;
      this.selectedDP = null;
    },
    onlyNumberKey(event) {
      const charCode = event.charCode ? event.charCode : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    tambahKota() {
      if (
        this.selectedCity &&
        !this.form.city_coverage.includes(this.selectedCity)
      ) {
        this.form.city_coverage.push(this.selectedCity)
      }
      this.selectedCity = ''
    },
    hapusKota(index) {
      this.form.city_coverage.splice(index, 1)
    },
    getCityText(value) {
      const found = this.options.city_arround.find(opt => opt.value === value)
      return found ? found.text : value
    },
    tambahJangkaWaktu() {
      const bulan = parseInt(this.selectedJangkaWaktu)
      const sudahAda = this.form.tenure_period.some(item => item[0] === bulan)

      if (bulan && !sudahAda) {
        this.form.tenure_period.push([bulan, 0]) // default persentase 0
        this.lockedPersentase.push(false)
      }

      this.selectedJangkaWaktu = ''
    },
    capitalizeWords(text) {
      if (!text) return '';
      return text
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
    },
    hapusJangkaWaktu(index) {
      this.form.tenure_period.splice(index, 1)
      this.lockedPersentase.splice(index, 1)
    },
    preventMinus(e) {
      if (e.key === '-' || e.code === 'Minus') {
        e.preventDefault(); // hanya mencegah jika karakter adalah '-'
      }
    },
    formatCurrency(value) {
      if (value === null || value === undefined || value === '' || isNaN(value)) return '';
      return 'Rp. ' + parseFloat(value).toLocaleString('id-ID');
    },
    parseCurrency(value) {
      return parseFloat(value.replace(/[^0-9,-]+/g, '').replace(',', '.')) || null;
    },
    async loadData() {
      let profile = this.currentUser.info;
      try{
        const result = await MitraProfile.show(profile.mitra_id);
          if (result.data.meta.code === 200) {
            this.pronvisiMitra = result.data.data.provinsi;
            
            try{
              const resultKota = await Kota.index(this.pronvisiMitra);
                this.options.city_arround = resultKota.data.kota_kabupaten.map(item => ({
                  value: item.id,
                  text: item.nama,
                }));
              } catch (error) {
                console.error('Error loading city data:', error);
              }
          }
        } catch (error) {
          console.error('Error loading profile data:', error);
        }
      try {
        const resultMarginType = await MarginType.index();
        this.options.margin_type = resultMarginType.data.data.map(item => ({
          value: item.id,
          text: item.name,
        }));;
      } catch (error) {
        console.error('Error loading margin type:', error);
      }
      try {
        this.isLoading = true;
        await this.loadOptionsData();

        if (this.paramsId != null) {
          this.updateSubmit = true;
          await this.loadProductData(this.paramsId);
        }
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async loadProductData(id) {
      try {
        const result = await Product.mitraShow(id);

        if (result.data.meta.code === 200) {
          this.form = result.data.data;

          this.form.tenure_period = JSON.parse(this.form.tenure_period || '[]');
          this.form.city_coverage = JSON.parse(this.form.city_coverage || '[]');
          this.form.sub_category_id = result.data.data.sub_category_id;
        } else if (result.data.meta.code === 404) {
          this.showForm = false;
          this.$bvToast.toast('Produk tidak ditemukan. Silakan cek ID produk atau hubungi administrator.', {
            title: 'Produk Tidak Ditemukan',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        } else if (result.data.meta.code === 403) {
          this.showForm = false;
          this.$bvToast.toast('Anda tidak memiliki izin untuk mengakses produk ini.', {
            title: 'Akses Ditolak',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          });
        } else {
          this.showForm = false;
          this.$bvToast.toast('Terjadi kesalahan saat memuat data produk. Silakan coba lagi nanti.', {
            title: 'Kesalahan Server',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        }
      } catch (error) {
        this.showForm = false;
        this.$bvToast.toast('Terjadi kesalahan saat memuat data produk. Silakan coba lagi nanti.', {
          title: 'Kesalahan Server',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
        console.error('Error loading product data:', error);
      }
    },
    async loadOptionsData() {
      try {
        const categoryResponse = await ProductCategory.index();
        this.options.category = categoryResponse.data.data.map(item => ({
          value: item.id,
          text: item.name,
        }));

        // Simpan UUID kategori "Pembiayaan"
        const pembiayaanCategory = categoryResponse.data.data.find(item => item.name.toLowerCase() === 'pembiayaan');
        if (pembiayaanCategory) {
          this.pembiayaanCategoryUUID = pembiayaanCategory.id;
        }

        const subCategoryResponse = await SubProductCategory.index();
        this.options.sub_category = subCategoryResponse.data.data.map(item => ({
          value: item.id,
          text: item.name,
          category_id: item.category_id,
        }));

        const brandResponse = await Brands.index();
        this.options.brands = brandResponse.data.data.map(item => ({
          value: item.id,
          text: item.name,
          sub_category_id: item.sub_category_id,
        }));

        const subBrandResponse = await SubBrands.index({ with: 'images' });
        const subBrands = subBrandResponse.data.data;
        this.options.subBrands = subBrands.map(item => ({
          value: item.id,
          text: item.name,
          brand_id: item.brand_id,
        }));
        this.subBrandImages = subBrands.flatMap(item => item.images || []);

        const akadResponse = await AkadSyariah.indexv3();
        // console.log("akad : ", akadResponse);
        this.options.akad = akadResponse.data.data.map(item => ({
          value: item.id,
          text: item.name,
        }));
        // console.log("akad opt : ", this.options.akad);
        

      } catch (error) {
        console.error('Error loading options data:', error);
      }
    },
    validateEqualRate() {
      if (this.form.akad_id == 2) {
        return true;
      }

      if (isNaN(this.form.equal_rate)) {
        this.equalRateError = 'Equal rate harus berupa angka.';
        this.scrollToTop();
        return false;
      }

      if (this.form.equal_rate == null || this.form.equal_rate == 0) {
        this.equalRateError = 'Equal rate harus di isi';
        this.scrollToTop();
        return false;
      }

      if (this.form.equal_rate > 100) {
        this.nisbahError = 'Equal rate maksimal 100%';
        this.scrollToTop();
        return false;
      }

      this.equalRateError = '';
      return true;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    async validateAndAddProduct() {
      this.isLoadSubmit = true;
      try {
        const res = await Product.getIsFillMitraData();
        if (res.data.meta.code === 200) {
          this.addProduct();
        } else {
          this.$bvToast.toast('Silakan lengkapi profil Anda terlebih dahulu sebelum menambahkan produk.', {
            title: 'Profil Tidak Lengkap',
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          });
        }
      } catch (error) {
        console.error('Error checking profile completeness:', error);
        this.$bvToast.toast('Terjadi kesalahan saat memeriksa kelengkapan profil.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      } finally {
        this.isLoadSubmit = false;
      }
    },
    addProduct() {
      this.confirmProductModal = true;
    },
    async confirmAddProduct() {
      this.isLoadSubmit = true;
      this.confirmProductModal = false;

      this.form.mitra_id = this.currentUser.info.mitra_id;
        if (this.form.is_nominal !== null) {
        const biaya = this.form.administration_fee;
        if (biaya === '' || biaya === null || biaya === undefined || isNaN(biaya)) {
          this.$bvToast.toast(
            this.form.is_nominal
              ? 'Biaya administrasi nominal wajib diisi.'
              : 'Biaya administrasi persentase wajib diisi.',
            {
              title: 'Validasi Gagal',
              variant: 'danger',
              solid: true,
              autoHideDelay: 4000,
            }
          );
          return; // Stop proses
        }
      }
      // console.log("form submit : ", this.form);
      try {
        // console.log("form submit : ", this.form);
        const res = await ProductLending.storeLending(this.form);
        if (res.data.meta.code === 200) {
          this.successModal = true;
          this.modalText = 'Produk berhasil dibuat, mohon tunggu persetujuan admin untuk produk tersebut';
        }
      } catch (error) {
        console.error('Error adding product:', error);
      } finally {
        this.isLoadSubmit = false;
      }
    },
    successConfirm() {
      this.$router.push('/dashboard');
    },
    async updateData() {
      try {
        this.isLoadSubmit = true;

        const res = await Product.update(this.form); 

        if (res.data.meta.code === 200) {
          this.successModal = true;
          this.modalText = 'Produk berhasil diubah, mohon tunggu persetujuan admin untuk produk tersebut';
        }
      } catch (error) {
        console.error('Error updating product:', error);
      } finally {
        this.isLoadSubmit = false;
      }
    },
  },
};
</script>

<style scoped>
.btn-switch {
  background-color: #fcb500 !important; /* default abu-abu */
  color: #ffffff;
  border: none;
  margin-right: 5px;
}

.btn-switch.active {
  background-color: #007bff !important; /* biru aktif */
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/public/dashboard/pembiayaan-form.vue